import api from "./api";

import { ModulockerSet } from "config/interfaces/ModulockerSet";


const getAll = () => {
  return api.get<ModulockerSet[]>("/api/templateset");
};

const getOne = (modulockerSetId: string) => {
  return api.get<ModulockerSet>(`/api/templateset/${modulockerSetId}`);
};

const deleteOne = (modulockerSetId: string) => {
  return api.delete(`/api/templateset/${modulockerSetId}`);
};

const update = (modulockerSetId: string, modulockerSet: ModulockerSet) => {
  return api.put(`/api/templateset/${modulockerSetId}`, modulockerSet);
};

const create = (modulockerSet: ModulockerSet) => {
  return api.post(`/api/templateset`, modulockerSet);
}

export { getAll, getOne, deleteOne, update, create };
